






























import { Vue, Component } from "@/shared/vuepack";
import { LinkedAccountsSettings } from "@/employee/route-names";

@Component({})
export default class LinkedAccountsWidget extends Vue {
  LinkedAccountsSettings = LinkedAccountsSettings;
}
